import src from "IMAGE";
export default { src, width: 105, height: 53, blurWidth: 0, blurHeight: 0};
